import StaticMap from './StaticMap.js';
import FloodAlertGroupSummaryComponent from './FloodAlertGroupSummaryComponent.js';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import CentralLink from './CentralLink.js';

function WaterBodySummaryComponent({ waterBodyName, geoJSON, floodAreas, waterBodyId }) {
    return <Row key={waterBodyId} style={{ display: 'flex', alignItems: 'center' }}>
        <Col xs={12} className="text-white bg-dark">
            <CentralLink to={'/data-explorer/water-bodies/' + encodeURI(waterBodyName)}><b>{waterBodyName}</b></CentralLink>
        </Col>
        <Col xs={4} className="g-0">
            {geoJSON && <CentralLink to={'/data-explorer/water-bodies/' + waterBodyName}><StaticMap style={{width: "100%", height: "180px"}} geoJSON={geoJSON} /></CentralLink>}
        </Col>
        <Col xs={8} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <Row style={{ display: 'flex', alignItems: 'center' }}> {/* Ensure this Row is a flex container */}
                <Col xs={12} lg={12} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <CentralLink to={'/data-explorer/water-bodies/' + waterBodyName}>
                        {
                            (floodAreas || []).length > 0 ?
                            <FloodAlertGroupSummaryComponent floodAreas={floodAreas} showIconOnNull={true} /> :
                            null
                        }
                    </CentralLink>
                </Col>
                <Col xs={12} lg={12} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <CentralLink to={'/data-explorer/water-bodies/' + waterBodyName}>
                        <Button variant="dark" size="sm">View Detailed Information</Button>
                    </CentralLink>
                </Col>
            </Row>
        </Col>
    </Row>
}

export default WaterBodySummaryComponent;
